import { TURNOVER_RATE, TURNOVER_VIEWS, TURNOVER_GROUPING, TURNOVER_GROUPINGS, TURNOVER_VIEW, TERMINATION_REASONS, GROUPING_ALLOW_DELETE } from "../../types";

const TurnoverReducer = (state = {}, action) => {
    if ([TURNOVER_RATE, TURNOVER_VIEWS, TURNOVER_GROUPING, TURNOVER_GROUPINGS, TURNOVER_VIEW, TERMINATION_REASONS, GROUPING_ALLOW_DELETE].includes(action.type)) {
        return { ...state, [action.type]: action.payload }
    }
    return state;
};

export default TurnoverReducer;
